import type { FC, ReactNode } from "react";
import { createContext, useContext, useState } from "react";

interface ComponentNameContextType {
  componentName: string;
  setComponentName: (name: string) => void;
}

const ComponentNameContext = createContext<ComponentNameContextType | undefined>(undefined);

export const ComponentNameProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [componentName, setComponentName] = useState<string>("Unknown");

  return (
    <ComponentNameContext.Provider value={{ componentName, setComponentName }}>
      {children}
    </ComponentNameContext.Provider>
  );
};

// Hook to use the ComponentNameContext
export const useComponentNameContext = () => {
  const context = useContext(ComponentNameContext);
  if (!context) {
    throw new Error("useComponentNameContext must be used within a ComponentNameProvider");
  }
  return context;
};
